import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MetodosPagosService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Metodos/Pagos/DataSource", varArgs, Sessions.header());
  }

  store(objMetodoPago : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Metodos/Pagos/Store", objMetodoPago, Sessions.header());
  }

  update(objMetodoPago : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Metodos/Pagos/Update", objMetodoPago, Sessions.header());
  }

  delete(objMetodoPago : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Metodos/Pagos/Delete", objMetodoPago, Sessions.header());
  }

}